import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, } from "../modifiers/index.js";
export const columnClassNames = ({ className, isCentered, isNarrow, offset, size, }) => classNames("column", modifier({ isCentered }), isNarrow === true
    ? {
        "is-narrow": isNarrow,
    }
    : isNarrow && typeof isNarrow === "object"
        ? Object.entries(isNarrow).map(([breakpoint, enabled]) => enabled ? `is-narrow-${breakpoint}` : undefined)
        : undefined, offset ? `is-offset-${offset}` : undefined, size
    ? size && typeof size === "object"
        ? Object.entries(size).map(([breakpoint, value]) => `is-${value}-${breakpoint}`)
        : `is-${size}`
    : undefined, className);
export const Column = ({ children, ...props }) => _jsx("div", { className: columnClassNames(props), children: children });
